// import React from 'react';

const EmptyLayout = ({children}) => children;

export default EmptyLayout;